import { Ionicons } from "@expo/vector-icons";
import React from "react";
import { TouchableOpacity, Text, StyleSheet, View, Platform } from "react-native";

import { useAppTheme } from "../../../design-system/ThemeProvider";
import { RESULTS_SHARED_WIDTH } from "./ResultsSharedWidth";

interface MultiplayerActionButtonProps {
  label: string;
  onPress: () => void;
  iconName?: string;
  iconColor?: string;
  iconSize?: number;
  style?: any;
  disabled?: boolean;
  accessibilityLabel?: string;
  variant?: "primary" | "secondary";
  loading?: boolean;
}

const MultiplayerActionButton: React.FC<MultiplayerActionButtonProps> = ({
  label,
  onPress,
  iconName,
  iconColor = "#4F46E5",
  iconSize = 22,
  style,
  disabled = false,
  accessibilityLabel,
  variant = "primary",
  loading = false
}) => {
  const { colors } = useAppTheme();

  return (
    <TouchableOpacity
      style={[
        { width: RESULTS_SHARED_WIDTH },
        styles.button,
        variant === "primary"
          ? [styles.primary, { backgroundColor: colors.primary, borderColor: colors.primaryPressed }]
          : [styles.secondary, { backgroundColor: colors.surfaceContainerLow, borderColor: colors.outlineVariant }],
        disabled ? styles.disabled : null,
        style
      ]}
      onPress={onPress}
      disabled={disabled || loading}
      accessibilityLabel={accessibilityLabel || label}
      accessibilityRole="button"
      activeOpacity={0.85}
    >
      {iconName && (
        <Ionicons
          name={iconName as any}
          size={iconSize}
          color={iconColor}
          style={styles.icon}
          accessibilityLabel={`${label} icon`}
        />
      )}
      <Text
        style={[
          styles.text,
          variant === "primary" ? styles.textPrimary : [styles.textSecondary, { color: colors.onSurface }]
        ]}
      >
        {loading ? "..." : label}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    paddingVertical: 13,
    borderRadius: 999,
    marginVertical: 6,

    borderWidth: 1.5,
  },
  primary: {
    backgroundColor: "#4F46E5",
    borderColor: "#4338CA",
  },
  secondary: {
    backgroundColor: "#FFFFFF",
    borderColor: "#E8E6EF",
  },
  disabled: {
    opacity: 0.6
  },
  icon: {
    marginRight: 10,
    marginLeft: 2
  },
  text: {
    fontWeight: "bold",
    fontSize: 18,
    color: "#1D1A23",
  },
  textPrimary: {
    color: "#FFFFFF",
  },
  textSecondary: {
    color: "#1D1A23",
  }
});

export default MultiplayerActionButton;
